// src/utils/globalModalCleanup.ts (Ultra Safe Version)

class ModalCleanupManager {
  private isInitialized: boolean;
  private cleanupInterval: number | null;

  constructor() {
    this.isInitialized = false;
    this.cleanupInterval = null;
  }

  /**
   * Ultra-safe cleanup - only modifies styles, never removes elements
   */
  public cleanup(): void {
    requestAnimationFrame(() => {
      const visibleModals = document.querySelectorAll('.modal.show');
      const allBackdrops = document.querySelectorAll('.modal-backdrop');
      
      // If no visible modals, hide backdrops with CSS only
      if (visibleModals.length === 0) {
        allBackdrops.forEach((backdrop) => {
          if (backdrop instanceof HTMLElement && backdrop.isConnected) {
            backdrop.style.display = 'none';
            backdrop.style.opacity = '0';
            backdrop.style.pointerEvents = 'none';
          }
        });
        
        // Reset body
        if (document.body.classList.contains('modal-open')) {
          document.body.style.overflow = '';
          document.body.style.paddingRight = '';
          document.body.style.position = '';
        }
      }
      
      // Hide inactive modals
      document.querySelectorAll('.modal:not(.show)').forEach((modal) => {
        if (modal instanceof HTMLElement && modal.isConnected) {
          modal.style.display = 'none';
          modal.style.pointerEvents = 'none';
        }
      });
    });
  }

  public init(): void {
    if (this.isInitialized) return;
    
    // Only use click and periodic cleanup
    document.addEventListener('click', () => {
      setTimeout(() => this.cleanup(), 300);
    }, true);
    
    // Periodic cleanup
    this.cleanupInterval = window.setInterval(() => this.cleanup(), 2000);
    
    this.isInitialized = true;
    // console.log('✅ Global Modal Cleanup initialized (Ultra Safe Mode)');
  }

  public destroy(): void {
    if (this.cleanupInterval) {
      clearInterval(this.cleanupInterval);
      this.cleanupInterval = null;
    }
    this.isInitialized = false;
  }
}

const modalCleanupManager = new ModalCleanupManager();
export default modalCleanupManager;